/**
 * Submitted hub visit — cold restore when status is already done.
 *
 * Belongs here: resting frame only (centered card, timeline, Done). No Framer springs.
 * Does not belong here: live submit motion (see HubInteractiveScreen).
 */
import { useEffect } from 'react'
import { getBottomPadding } from '../../../../utils/sessionStorage'
import { EventNames } from '../../../../types/misc.types'
import { trackEvent } from '../../../../utils/appBridge'
import { ExpertReviewScreen } from '../analytics/expertReviewEvents'
import { expertReviewSafeAreaTopStyle } from '../shared/expertReviewSafeArea'
import { HubCardBody, type HubPortfolioSummary } from './HubCard'
import { HubDoneFooter, HubReviewTimeline, HubSubmitPhase } from './HubSubmit'

export function HubSubmittedScreen({
  summary,
  firstPlanDropTime,
  onDone
}: {
  summary: HubPortfolioSummary
  /** From status. Null shows the “few days” line instead of the countdown. */
  firstPlanDropTime: number | null
  onDone: () => void
}) {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: { ScreenName: ExpertReviewScreen.Hub }
    })
  }, [])

  return (
    <div
      style={{
        ...expertReviewSafeAreaTopStyle(),
        paddingBottom: `calc(${getBottomPadding()}px + 16px)`
      }}
      className="relative flex h-screen flex-col overflow-hidden bg-white px-5"
    >
      <div className="relative z-0 min-h-0 flex-1 overflow-y-auto no-scrollbar">
        <div className="flex min-h-full flex-col">
          <div className="min-h-0 flex-1" />
          <div className="relative w-full shrink-0">
            <HubCardBody
              userName={summary.userName}
              portfolioValue={summary.portfolioValue}
              fundCount={summary.fundCount}
              submitPhase={HubSubmitPhase.Submitted}
            />
            <div className="pt-8 pb-20">
              <HubReviewTimeline firstPlanDropTime={firstPlanDropTime} />
            </div>
          </div>
          <div className="min-h-0 flex-1" />
        </div>
      </div>

      <HubDoneFooter show animateEnter={false} onDone={onDone} />
    </div>
  )
}
